import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { getPublicConfig } from "@/lib/public-config.functions";

let clientPromise: Promise<SupabaseClient> | null = null;

export function describeSupabaseInitError(step: string, err: unknown) {
  const message = err instanceof Error ? err.message : String(err);
  const status =
    err != null && typeof err === "object" && "status" in err
      ? Number((err as { status: number }).status)
      : undefined;

  const hint =
    message === "Forbidden" || status === 403
      ? "Server function CSRF rejected — verify APP_ORIGIN and nginx proxy headers (Host, X-Forwarded-Proto)"
      : status === 500
        ? "Server function failed — verify EXT_SUPABASE_URL and EXT_SUPABASE_ANON_KEY on the VPS"
        : undefined;

  return {
    step,
    message,
    ...(status !== undefined && !Number.isNaN(status) ? { status } : {}),
    ...(hint ? { hint } : {}),
  };
}

export function getSupabaseClient(): Promise<SupabaseClient> {
  if (!clientPromise) {
    clientPromise = getPublicConfig()
      .then(({ supabaseUrl, supabaseAnonKey }) =>
        createClient(supabaseUrl, supabaseAnonKey, {
          auth: {
            persistSession: true,
            autoRefreshToken: true,
            storageKey: "dealdraft-auth",
          },
        }),
      )
      .catch((err) => {
        console.error(
          "[DealDraft] Supabase init failed:",
          describeSupabaseInitError("getPublicConfig", err),
        );
        throw err;
      });
  }
  return clientPromise;
}
